import styled from "styled-components";

export const Container = styled.div`
  margin: 0 10%;
  td {
    color: #696969;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  tr :last-child {
    font-weight: 400;
  }
`;
export const InfoContact = styled.div`
  color: #000;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 1em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 2em;
  }
`;
export const ContactUs = styled.span`
  cursor: pointer;
  color: #000;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
`;

export const Menu = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 0.6875rem;
  margin-top: 2em;
  display: flex;
  align-self: center;
  justify-content: space-between;
  div {
    width: 0.0625rem;
    height: 0.875rem;
    flex-shrink: 0;
    background: #d9d9d9;
  }
  .active {
    color: #000;
    font-family: Poppins;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  h5 {
    color: #696969;
    font-family: Poppins;
    font-size: 0.875em;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
    /* margin-right: 2em; */
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 80%;
    margin: 1.5em auto;
  }
`;

export const Info = styled.div`
  width: 100%;
  height: fit-content;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
